<template>
	<!-- Modal -->
	<div v-if="isOpen !== null && user" class="modal fade" id="userEditModal" tabindex="-1"
			 aria-labelledby="exampleModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">მომხმარებლის ედიტირება: {{ user.nickname }}</h5>
					<button type="button" class="btn-close" id="close-modal" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<!-- Tabs Navigation -->
				<ul class="nav nav-tabs" id="userTabs" role="tablist">
					<li @click="setActiveTab('userData')" class="nav-item" role="presentation">
						<a class="nav-link active" id="userData-tab" data-bs-toggle="tab" href="#userData" role="tab"
							 aria-controls="userData" aria-selected="true">მთავარი ინფორმაცია</a>
					</li>
					<li @click="setActiveTab('permissions')" class="nav-item" role="presentation">
						<a class="nav-link" id="permissions-tab" data-bs-toggle="tab" href="#permissions" role="tab"
							 aria-controls="permissions" aria-selected="false">უფლებები </a>
					</li>
				</ul>

				<form class="popup-form" @submit.prevent="updateUser(user)">
					<div class="modal-body">
						<!-- Tabs Content -->
						<div class="tab-content" id="userTabsContent">
							<!-- User Data Tab -->
							<div class="tab-pane show active" id="userData" role="tabpanel" aria-labelledby="userData-tab">
								<!-- Nickname -->
								<div class="mb-3">
									<label for="nickname" class="form-label">Nickname</label>
									<input type="text" class="form-control" id="nickname" v-model="user.nickname">
								</div>

								<div class="row mb-3">
									<!-- Name -->
									<div class="col form-group">
										<label for="name" class="form-label">Name</label>
										<input type="text" class="form-control" id="name" v-model="user.name">
									</div>

									<!-- Surname -->
									<div class="col form-group">
										<label for="surname" class="form-label">Surname</label>
										<input type="text" class="form-control" id="surname" v-model="user.surname">
									</div>
								</div>

								<div class="row mb-3">
									<!-- Email -->
									<div class="col form-group">
										<label for="email" class="form-label">Email</label>
										<input type="email" class="form-control" id="email" v-model="user.email">
									</div>

									<!-- Phone Number -->
									<div class="col form-group">
										<label for="tel" class="form-label">Phone Number</label>
										<input type="tel" class="form-control" id="tel" v-model="user.tel">
									</div>
								</div>

								<div class="row mb-3">
									<!-- Language -->
									<div class="col-6">
										<label for="language" class="form-label">Language</label>
										<select class="form-control" id="language" v-model="user.language">
											<option value="GE">ქართული</option>
											<option value="EN">English</option>
											<!-- You can add other languages here if needed -->
										</select>
									</div>
								</div>

								<div class="row mb-3">
									<!-- Active Status -->
									<div class="col form-group">
										<input type="checkbox" class="form-check-input me-2" id="aktiv" v-model="user.aktiv">
										<label class="form-check-label" for="aktiv">Active</label>
									</div>

								</div>

								<!-- Description -->
								<div class="mb-3">
									<label for="description" class="form-label">Description</label>
									<textarea class="form-control" id="description" rows="3" v-model="user.description"></textarea>
								</div>
							</div>

							<!-- Permissions Tab -->
							<div class="tab-pane" id="permissions" role="tabpanel" aria-labelledby="permissions-tab">
								<table class="table">
									<thead>
									<tr>
										<th>უფლება</th>
										<th class="text-center">ნახვა</th>
										<th class="text-center">ჩაწერა</th>
										<th class="text-center">წაშლა</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(permission, key) in permissions" :key="key">
										<td>{{ $t(permission.name) }}</td>
										<td class="text-center">
											<input class="form-check-input" type="checkbox" :id="'read-' + key"
														 v-model="user.permissions[permission.id].read">
										</td>
										<td class="text-center">
											<input class="form-check-input" type="checkbox" :id="'write-' + key"
														 v-model="user.permissions[permission.id].write">
										</td>
										<td class="text-center">
											<input class="form-check-input" type="checkbox" :id="'delete-' + key"
														 v-model="user.permissions[permission.id].delete">
										</td>
									</tr>
									</tbody>
								</table>
							</div>

						</div>
					</div>
					<div class="modal-footer">
						<!-- Previous Button -->
						<button v-if="activeTab !== 'userData'" class="btn btn-secondary" @click="setActiveTab('userData')">წინა
						</button>

						<!-- Next Button -->
						<button v-if="activeTab !== 'permissions'" class="btn btn-secondary" @click="setActiveTab('permissions')">
							შემდეგი
						</button>

						<!-- Save Button (only on last tab) -->
						<button v-if="activeTab === 'permissions'" class="btn btn-primary">შენახვა</button>
					</div>
				</form>

			</div>
		</div>
	</div>
</template>


<script>
export default {
	name: 'EditUserPopup',
	props: ['user', 'isOpen'],
	watch: {
		isOpen(newVal) {
			if (newVal) {
				this.showModal();
			} else {
				this.hideModal();
			}
		}
	},
	computed: {
		permissions() {
			let allPermissions = this.$store.state.user.permissions;

			// Initialize user.permissions if not already set
			this.user.permissions = this.user.permissions || {};

			let mergedPermissions = {};

			for (let id in allPermissions) {
				if (this.user.permissions[id]) {
					mergedPermissions[id] = {
						...allPermissions[id],
						...this.user.permissions[id]
					};
					mergedPermissions[id]['name'] = allPermissions[id]['name'];
				} else {
					mergedPermissions[id] = {
						...allPermissions[id],
						read: false,
						write: false,
						delete: false
					};
					// Initialize user.permissions for this permission
					this.user.permissions[id] = {
						id: allPermissions[id].id,
						read: false,
						write: false,
						delete: false
					};
				}
			}

			return mergedPermissions;
		},
	},
	mounted() {
		if (this.isOpen) {
			this.showModal();
		}
	},
	methods: {
		showModal() {
			let myModal = new bootstrap.Modal(document.getElementById('userEditModal'), {
				keyboard: false
			});
			myModal.show();
			myModal._element.addEventListener('hidden.bs.modal', () => {
				this.$emit('update:isOpen', false);
			});
		},
		hideModal() {
			let myModal = bootstrap.Modal.getInstance(document.getElementById('userEditModal'));
			if (myModal) {
				myModal.hide();
			}
		},
		updateUser(data) {
			this.$store.dispatch('user/update', data).then(
					() => {
						document.getElementById('close-modal').click()
					}
			)
			this.$store.dispatch('user/users').then(
					() => this.loading = false
			)

		},
		setActiveTab(tabName) {
			this.activeTab = tabName;
			// Use bootstrap's tab showing method
			new bootstrap.Tab(document.getElementById(tabName + '-tab')).show();
		},
	},
	data() {
		let form = {
			name: '',
			surname: '',
			email: '',
			tel: '',
			language: '',
			current_password: '',
			password: '',
			password_confirmation: ''
		}
		return {
			activeTab: 'userData',  // Default to the first tab
		};
	}
}
</script>


<style scoped>


.modal {
	z-index: 99999;
}

.popup-form {
	text-align: left;
}

.table tbody tr:last-child {
	border: 1px solid #eaf0f8;
}

</style>